.BenefitsIcon {
  top: -65px;
}

.BenefitsIconGap {
  margin-top: 50px;
}

.BenefitsIconDistance {
  margin-top: 100px;
}
